<template>
	<div class="company-shipping-card-edit" :value="value">
		<Input
			class="company-shipping-card-edit__code"
			label="Code"
			v-model="localData.code"
		/>

		<Input
			label="URL"
			v-model="localData.url"
		/>

		<Textarea
			label="Description"
			v-model="localData.description"
			:cols="30"
			:rows="3"
			:maxLength="250"
		/>

		<span class="company-shipping-card-edit__delete"
			><Button
				className="btn--icon-only"
				iconClassName="icon-delete-glenn"
				:iconBeforeLabel="true"
			/>
		</span>
	</div>
</template>

<script>
import Input from '@/components/forms/input/input';
import Textarea from '@/components/forms/textarea/textarea.vue';
import Button from '@/components/forms/button/button';
// import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import _ from 'lodash';

export default {
	name: 'CompanyShippingCardEdit',
	components: { Input, Textarea, Button },
	props: {
		value: {
			type: Object,
			default: () => {}
		},
		item: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.item)
		};
	},
	created() {
		// console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-shipping-card-edit {
	@include card;
	padding: $padding-md;
	width: 384px;
	display: flex;
	flex-direction: column;
	gap: $gutter-lg;

	&:hover,
	&:active {
		-o-outline: $focus-outline;
		-moz-outline: $focus-outline;
		outline: $focus-outline;
		outline-offset: $focus-offset;
	}

	&__code {
		width: 125px;
	}
	&__delete {
		align-self: flex-end;
		.btn--icon-only {
			font-size: 24px;
		}
	}
}
</style>
